import React, { useEffect } from 'react';
import { Routes, Route, useSearchParams } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import LandingPage from './pages/LandingPage';
import FeaturesPage from './pages/FeaturesPage';
import PricingPage from './pages/PricingPage';
import ContactPage from './pages/ContactPage';
import AboutPage from './pages/AboutPage';
import TermsOfServicePage from './pages/TermsOfServicePage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import CookiePolicyPage from './pages/CookiePolicyPage';
import HelpCenterPage from './pages/HelpCenterPage';
import DocumentationPage from './pages/DocumentationPage';
import StatusPage from './pages/StatusPage';

// Redirect to Client app's register page
function RegisterRedirect() {
  const [searchParams] = useSearchParams();
  useEffect(() => {
    const clientUrl = process.env.REACT_APP_APP_URL || 'https://localhost:6001';
    const plan = searchParams.get('plan');
    const url = plan ? `${clientUrl}/register?plan=${plan}` : `${clientUrl}/register`;
    window.location.href = url;
  }, [searchParams]);
  return null;
}

function App() {
  return (
    <>
      <Navbar />
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/features" element={<FeaturesPage />} />
        <Route path="/pricing" element={<PricingPage />} />
        <Route path="/register" element={<RegisterRedirect />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/terms" element={<TermsOfServicePage />} />
        <Route path="/privacy" element={<PrivacyPolicyPage />} />
        <Route path="/cookies" element={<CookiePolicyPage />} />
        <Route path="/help" element={<HelpCenterPage />} />
        <Route path="/docs" element={<DocumentationPage />} />
        <Route path="/status" element={<StatusPage />} />
      </Routes>
      <Footer />
    </>
  );
}

export default App;
